import { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Button, Button as ModalButton, Card, CardBody, Col, Modal, ModalFooter, ModalHeader, Row } from 'reactstrap';

import Hr from '../hr/hr';
import PastDaysOfActivity from '../past-days-activity/past-days-of-activity';
import Pill from '../pill/pill';

import './player-card.css';

class PlayerCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowArchiveModal: false,
      isShowDeleteModal: false,
      startingGameSession: false,
    };
  }

  prepareActiveDates(activeDates) {
    const activityDatesDict = {};
    const toReturn = [];
    for (let i = 0; i < activeDates.length; i++) {
      toReturn.push(new Date(activeDates[i]['day']));
      activityDatesDict[activeDates[i]['day']] = activeDates[i]['activity_count'];
    }

    return [toReturn, activityDatesDict];
  }

  setButtonLoader() {
    this.setState({
      startingGameSession: true,
    });
  }

  render() {
    const { activities, results, player, isReady, isExtended, onClickPlayActiveSession, isOwner } = this.props;

    const _created = new Date(player._created);
    const createdDisplay = `${_created.getMonth() + 1}/${_created.getDate()}/${_created.getFullYear()}`;

    let hasGameSessions = player.number_of_game_sessions > 0;
    let activeSessionDisplay = player.active_game_session ? player.active_game_session.name : null;
    activeSessionDisplay = activeSessionDisplay ? activeSessionDisplay : '<No Active Session>';

    hasGameSessions = hasGameSessions || activeSessionDisplay !== '<No Active Session>';

    let activityDates;
    let activityDict;
    if (player.activity_dates) {
      activityDates = this.prepareActiveDates(player.activity_dates);
      activityDict = activityDates[1];
      activityDates = activityDates[0];
    } else {
      activityDates = [];
      activityDict = {};
    }

    return (
      <Card className="shadow">
        <CardBody className="mx-2 pt-1">
          <Row>
            <h4 className="mb-0 pb-0">{player.name}</h4>
            <br />
          </Row>
          <Row className="my-0 py-0">
            <span className="m-0 p-0 very-small secondary-color">Created On {createdDisplay}</span>
          </Row>
          <Row>
            <div className="mt-1 container-fluid">
              <Hr />
            </div>
            <Col md={isExtended ? '3' : '6'} className="text-left">
              <Row>Active Session</Row>
              <Row>
                <p className="m-0 p-0 small secondary-color">{activeSessionDisplay}</p>
              </Row>
              {player.owner_name && <Row className="mt-1">Owner</Row>}
              {player.owner_name && (
                <Row>
                  <p className="m-0 p-0 small secondary-color">{`${player.owner_name}`}</p>
                </Row>
              )}
            </Col>
            <Col md={isExtended ? '3' : '6'} className="text-left">
              <Row>{isExtended ? 'Past 28 days of activity' : 'Past 7 days of activity'}</Row>
              <PastDaysOfActivity
                activeDays={activityDates}
                activityDict={activityDict}
                numberOfWeeks={isExtended ? 4 : 1}
              />
            </Col>
            {isExtended && (
              <Col md="6" className="my-3 pl-4 text-left border-left background-light-grey-color">
                <Row>
                  <span className="font-italic">Notes:</span>
                </Row>
                <Row>
                  <p className="ml-2 small secondary-color">{player.notes}</p>
                </Row>
              </Col>
            )}
          </Row>
          <Row>Targeted Skills</Row>
          <Row className="mb-2">{this.mapSkills(player.skills)}</Row>
          <Row>
            <div className="mt-0 mb-2 container-fluid">
              <Hr />
            </div>
            <div className="ml-0 pl-0 text-left container-fluid">
              {!this.props.isArchive && !isExtended && (
                <NavLink
                  to={{
                    pathname: `/player/${player.id}/dashboard`,
                    player: player,
                    results: results,
                    activities: activities,
                  }}
                >
                  <Button size="sm" disabled={!isReady} className="sm player_profile_button">
                    Player Profile
                  </Button>
                </NavLink>
              )}

              {!this.props.isArchive && hasGameSessions && !this.state.startingGameSession && (
                <Button
                  className="play_active_session_button"
                  onClick={() => {
                    onClickPlayActiveSession();
                    this.setButtonLoader();
                  }}
                  disabled={!isReady}
                >
                  <i className="fa fa-play" /> Play Active Session{' '}
                </Button>
              )}

              {!this.props.isArchive && hasGameSessions && this.state.startingGameSession && (
                <span>
                  <i className="fa fa-spinner fa-spin"></i> Working...
                </span>
              )}

              {!this.props.isArchive && isExtended && (
                <NavLink
                  to={{
                    pathname: `/player/${player.id}`,
                    player: player,
                    returnRoute: `/player/${player.id}/dashboard`,
                  }}
                >
                  <Button size="sm" className="player_overview_edit" outline>
                    Edit Player
                  </Button>
                </NavLink>
              )}

              {!this.props.isArchive && !hasGameSessions && (
                <NavLink
                  to={{
                    pathname: `/gameSession`,
                    player: player,
                  }}
                >
                  <Button size="sm" disabled={!isReady} className="player_card_design_session_button">
                    Design Session
                  </Button>
                </NavLink>
              )}

              {/* {isExtended &&
                            <Button size="sm" color="danger" outline className="mr-1 float-right" onClick={() => {
                                this.setState({isShowDeleteModal: true})
                            }}>Delete</Button>
                            } */}

              {isExtended && (
                <Button
                  size="sm"
                  color="warning"
                  outline
                  className="mr-1 float-right"
                  onClick={() => {
                    this.setState({ isShowArchiveModal: true });
                  }}
                >
                  Archive
                </Button>
              )}

              {this.props.isArchive && (
                <Button
                  size="sm"
                  color="primary"
                  className="mr-1"
                  onClick={() => {
                    this.setState({ isShowArchiveModal: true });
                  }}
                >
                  Unarchive
                </Button>
              )}
            </div>
          </Row>
        </CardBody>
        <Modal isOpen={this.state.isShowArchiveModal} className={this.props.className} backdrop={this.state.backdrop}>
          <ModalHeader>{`Are you sure you want to ${isExtended ? '' : 'un'}archive this player?`}</ModalHeader>
          <ModalFooter>
            {isOwner && isExtended && (
              <span>
                <ModalButton
                  className="ml-3"
                  color={isExtended ? 'secondary' : 'danger'}
                  onClick={() => {
                    this.setState({ isShowArchiveModal: false });
                  }}
                >
                  Do Not Archive
                </ModalButton>
                <ModalButton
                  className="ml-3"
                  color={isExtended ? 'info' : 'info'}
                  onClick={() => {
                    this.props.archivePlayer(player.id);
                  }}
                >
                  Archive for me
                </ModalButton>

                <ModalButton
                  className="ml-3"
                  color={isExtended ? 'danger' : 'primary'}
                  onClick={() => {
                    this.props.archivePlayer(player.id, true);
                  }}
                >
                  Archive for all
                </ModalButton>
              </span>
            )}

            {(!isOwner || !isExtended) && (
              <span>
                <ModalButton
                  className="ml-3"
                  color={isExtended ? 'primary' : 'danger'}
                  onClick={() => {
                    this.setState({ isShowArchiveModal: false });
                  }}
                >
                  Do Not {isExtended ? 'A' : 'Una'}rchive
                </ModalButton>
                <ModalButton
                  className="ml-3"
                  color={isExtended ? 'danger' : 'primary'}
                  onClick={() => {
                    this.props.archivePlayer(player.id);
                  }}
                >
                  Yes
                </ModalButton>
              </span>
            )}
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.isShowDeleteModal} className={this.props.className} backdrop={this.state.backdrop}>
          <ModalHeader>{`Are you sure you want to delete this player?`}</ModalHeader>
          <ModalFooter>
            <ModalButton
              className="ml-3"
              color="info"
              onClick={() => {
                this.setState({ isShowDeleteModal: false });
              }}
            >
              Do Not Delete
            </ModalButton>
            <ModalButton
              className="ml-3"
              color="danger"
              onClick={() => {
                this.props.deletePlayer(player.id);
              }}
            >
              Yes
            </ModalButton>
          </ModalFooter>
        </Modal>
      </Card>
    );
  }

  mapSkills = (playerSkills) => {
    if (!playerSkills || !this.props.skills || this.props.skills.length === 0) {
      return;
    }
    // const propSkills = this.props.skills;
    // const _playerSkills = playerSkills.map(skill => propSkills.find(propSkill => propSkill.id === skill));
    playerSkills.sort((a, b) => a.name > b.name);

    return playerSkills.map((_skill) => {
      return (
        <span key={`skill_pill_${_skill.id}`} className="mr-1">
          <Pill isSmall hidePointer label={_skill.name} />
        </span>
      );
    });
  };
}

export default PlayerCard;
